import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import LineChartPart from '../../common/part/LineChartPart';
import { momentFormat } from '../../../../utils/format/time';
import { useAdminUser } from '../../../../utils/custom-hooks/common/useAdminUser';
import { apiAdmGetChartOrder, apiAdmGetChartReview, apiAdmGetChartVisit } from '../../../../api/api_adm_home';

export default function AdminHomeChartPart() {
    const adminUser = useAdminUser();
    const [list,setList] = useState<any>([]);

    useEffect(()=>{
        if(adminUser.admin_id === 0) return;
        getList();
    },[adminUser.admin_id]);

    const getList = async() =>{
        const visit = await apiAdmGetChartVisit(adminUser.admin_token,adminUser.admin_id,30);
        const order = await apiAdmGetChartOrder(adminUser.admin_token,adminUser.admin_id,30);
        const review = await apiAdmGetChartReview(adminUser.admin_token,adminUser.admin_id,30);
        let list1:any = [];
        let list2:any = [];
        let list4:any = [];
        if(visit.result){
            list1 = visit.data.map((data:any)=>({name: momentFormat('MM-DD',data.timestamp),visitor:data.count}));
        }
        if(order.result){
            list2 = order.data.map((data:any)=>({name: momentFormat('MM-DD',data.timestamp),order:data.count}))
        }
        if(review.result){
            list4 = review.data.map((data:any)=>({name: momentFormat('MM-DD',data.timestamp),review:data.count}))
        }
        
        const res = mergeArrays([list1,list2,list4]);
        
        setList(res.reverse());
    }

    const mergeArrays = (arrays:any) => {
        const merged = arrays.reduce((acc:any, arr:any) => {
            arr.forEach((item:any) => {
                const existingItem = acc.find((i:any) => i.name === item.name);
                if (existingItem) {
                    Object.assign(existingItem, item);
                } else {
                    acc.push(item);
                }
            });
            return acc;
        }, []);
        return merged;
    };
    
    return (
        <Wrap>
            <InnerWrap>
                <LineChartPart list={list} />
            </InnerWrap>
        </Wrap>
    )
}

const Wrap = styled.div`
    width: 100%;
    overflow-x: auto;
`;

const InnerWrap = styled.div`
    width: 100%;
    min-width: 600px;
`;